import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const ScannedProductSchema_ = z.object({
  productId: z.string().optional(),
  productFamilyId: z.string().optional(),
  sku: z.string().nullish(),
  upc: z.string().nullable(),
  barcodes: z.array(z.string()),
  title: z.string(),
  description: z.string().nullable(),
  images: z.array(
    z.object({ url: z.string(), altText: z.string().nullable() }),
  ),
  optionValues: z.array(z.string()),
  price: z.number().nullable(),
  vendor: z.string().nullable(),
  teamId: z.string(),
  teamName: z.string(),
});
export const ScannedProductSchema: z.ZodType<ScannedProduct> =
  ScannedProductSchema_;
export interface ScannedProduct extends z.infer<typeof ScannedProductSchema_> {}

export const ReturnProductSchema_ = ScannedProductSchema_.extend({
  returnId: zExt.objectId(),
  returnProductId: zExt.objectId(),
  orderNumber: z.string(),
  quantity: z.number(),
  isFinalSaleReturn: z.boolean(),
});

export const ReturnProductSchema: z.ZodType<ReturnProduct> =
  ReturnProductSchema_;
export interface ReturnProduct extends z.infer<typeof ReturnProductSchema_> {}

// Discriminated union for different types of scan results
export const ScanLabelResultSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("return_lookup"),
    products: z.array(ReturnProductSchema),
  }),
  z.object({
    type: z.literal("product_lookup"),
    products: z.array(ScannedProductSchema),
  }),
]);

export type ScanLabelResult = z.infer<typeof ScanLabelResultSchema>;

export const scanLabelLookup = unaryRpc({
  name: "scanLabelLookup" as const,
  input: z.object({ code: z.string() }),
  output: ScanLabelResultSchema,
});
